import RenderCards from "../../../utilities/cards/RenderCards";

export default class ArticleStorage {
  config = {
    storageKey: process.env.ARTICLE_STORAGE_KEY,
    resultSelector: ".article__results",
    noResults: "<p class='fade-in'>Sorry, no article history available.</p>",
    templateId: "bookmark-template",
    buttonClass: ".bookmark_button",
  };

  constructor(config = {}) {
    this.config = { ...this.config, ...config };
    if (!this.storageAvailable("localStorage")) {
      console.log("No local storage available");
    } else {
      this.pruneExpired();
      this.getArticles();
    }
  }

  pruneExpired() {
    this.getArticles();

    // do we have any expired entries?
    const currentList = this.list.filter((i) => {
      return parseInt(i?.expiry) > Date.now();
    });

    if (currentList) {
      if (currentList.length !== this.list.length) {
        this.list = currentList;
        this.storeArticles();
      }
    }
  }

  renderArticles() {
    // render the results?
    if (this.config.resultSelector) {
      this.resultsElem = document.querySelector(this.config.resultSelector);
      // render list if not empty
      if (this.resultsElem) this._renderArticles();
    }
  }

  storageAvailable(type) {
    try {
      var storage = window[type],
        x = "__storage_test__";
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return false;
    }
  }

  getArticles() {
    let list;
    list = localStorage.getItem(this.config.storageKey);
    if (list === "undefined" || !list) list = [];
    else list = JSON.parse(list);
    this.list = list ? list : [];
  }

  // store all articles
  storeArticles() {
    localStorage.setItem(this.config.storageKey, JSON.stringify(this.list));
    this.getArticles();
  }

  // store a single bookmark
  addArticle(data) {
    data.expiry = new Date().getTime() + 30 * 24 * 60 * 60 * 1000;
    this.list.push(data);
    this.storeArticles();
  }

  // given a source element with a data attribute name, decode the base64 and push the object to local storage (recent articles)
  // this can be a bookmark button OR a hidden div on the articles page with an encoded base64 string
  updateArticle(sourceElement, attribute = "data-article") {
    if (!sourceElement) return;
    if (sourceElement.getAttribute("recent-saved") !== "true") {
      const base64 = sourceElement.getAttribute(attribute);
      if (base64) {
        const data = JSON.parse(atob(base64));
        if (data) {
          // commit the article data
          this._updateArticle(data);
          // set it to saved so we dont process it again for this current load
          sourceElement.setAttribute("recent-saved", "true");
        }
      }
    }
  }

  _updateArticle(data) {
    // if this already exists in local storage, delete and re-add it
    var foundIndex = this.list.findIndex((x) => x.id == data.id);
    if (foundIndex > -1) {
      data.expiry = new Date().getTime() + 30 * 24 * 60 * 60 * 1000;
      this.list[foundIndex] = data;
      this.storeArticles();
    } else {
      this.addArticle(data);
    }
  }

  // render the list of bookmark cards
  _renderArticles() {
    // render the template
    const data = {
      list: this.list,
      resultElement: this.resultsElem,
      noResults: this.config.noResults,
      templateId: this.config.templateId,
    };

    const render = new RenderCards(data);
    this.resultsElem.innerHTML = render.render();

    setTimeout(() => {
      render.hydrate();
    }, 250);
  }
}
